module.exports = __webpack_public_path__ + "static/media/287.cb0c824e.png";